import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardFooter, CardHeader, Col, Row, Table,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { deleteWebCity, fetchWebCity } from '../../actions/web-cities';
import PinModal from '../../components/pin';

const DetailRow = ({ label, value }) => (
  <tr>
    <td>{label}</td>
    <td><strong>{value === null || value === undefined ? '' : String(value)}</strong></td>
  </tr>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DetailRow.defaultProps = { value: '' };

class WebCity extends React.Component {
  constructor(props) {
    super(props);
    this.state = { submitted: false };
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillMount() {
    const { getWebCity } = this.props;
    getWebCity();
  }

  handleDelete() {
    const { deleteAction, goToList } = this.props;
    deleteAction().then((result) => {
      if (result.ok) goToList();
      else this.setState({ submitted: false });
    });
  }

  render() {
    const { city, goToEdit } = this.props;
    const { submitted } = this.state;
    if (!city || Object.keys(city).length === 0) return null;
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleDelete}
            failedSubmit={() => this.setState({ submitted: false })}
          />
        )}
        <Row>
          <Col lg={8}>
            <Card>
              <CardHeader>
                <strong>{`Web City ID: ${city.id}`}</strong>
                <div className="card-header-actions">
                  <Button color="link" className="card-header-action btn-setting" onClick={goToEdit}>
                    <i className="icon-note" />
                  </Button>
                  <Button color="link" className="card-header-action btn-setting" onClick={() => this.setState({ submitted: true })}>
                    <i className="icon-trash" />
                  </Button>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <DetailRow label="ID:" value={city.id} />
                    <DetailRow label="English Name:" value={city.name_en} />
                    <DetailRow label="French Name:" value={city.name_fr} />
                    <DetailRow label="Arabic Name:" value={city.name_ar} />
                    <DetailRow label="Web Country:" value={city.webCountry && (city.webCountry.name_en || city.webCountry.name_fr || city.webCountry.name_ar)} />
                    <DetailRow label="Web Country ID:" value={city.web_country_id} />
                    <DetailRow label="Original City:" value={city.city && city.city.name} />
                    <DetailRow label="Original City ID:" value={city.city_id} />
                    <DetailRow label="Latitude:" value={city.latitude} />
                    <DetailRow label="Longitude:" value={city.longitude} />
                    <DetailRow label="IANA Timezone:" value={city.timezone} />
                    <DetailRow label="Priority:" value={city.priority} />
                    <DetailRow label="Enabled:" value={city.enabled} />
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button color="secondary" size="sm" onClick={goToEdit}>Edit</Button>
                {' '}
                <Button color="danger" size="sm" onClick={() => this.setState({ submitted: true })}>Delete</Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

WebCity.propTypes = {
  city: PropTypes.shape({}),
  deleteAction: PropTypes.func.isRequired,
  getWebCity: PropTypes.func.isRequired,
  goToEdit: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
};
WebCity.defaultProps = { city: {} };

const mapStateToProps = ({ webCities }) => ({ city: webCities.item });
const mapDispatchToProps = (dispatch, ownProps) => bindActionCreators({
  deleteAction: () => deleteWebCity(ownProps.match.params.id),
  getWebCity: () => fetchWebCity(ownProps.match.params.id),
  goToEdit: () => push(`/web-cities/${ownProps.match.params.id}/edit`),
  goToList: () => push('/web-cities'),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(WebCity);
